export default import.meta.ROLLUP_FILE_URL_V1ZYpwZc9C51fJhgOTS5xQ;